import { SpinnerWrapper } from './Spinner.styled';

export const Spinner = () => <SpinnerWrapper />;
